/*
TODO: rewrite to logger service, configure via env/init.
  make work in conjunction with console logger.
  rename to avoid confusion with kibana.
*/

import scopeLogger from '#/lib/scope-logger.js';
import { Queue } from '#/lib/queue.js';

export default Kibana;

const console = scopeLogger('RMI:Kibana');
/*
 for debug purpose may try to use http://log.cnt.re:7080/debug/log/
 */
const url = `//log.cnt.re/log/interactive`;
const logLevels = ['debug', 'info', 'log', 'warn', 'error', 'fatal'];

const sessionContext = {
  app: {
    version: import.meta.env.VITE_APP_VERSION,
    build: import.meta.env.VITE_BUILD_LABEL,
  },
};
let send = navigator.sendBeacon
  ? navigator.sendBeacon.bind(navigator, url)
  : function (data) {
      const request = new XMLHttpRequest();
      request.open('POST', url, true);
      request.send(data);
    };
if (import.meta.env.MODE === 'development') {
  send = function (data) {
    const text = data.get('text');
    const payload = JSON.parse(data.get('data'));
    console.log('no actual send', text, payload);
  };
}

const queue = new Queue(1000);
let consumerQueue = queue.subscribe(send);

window.addEventListener('online', (_e) => {
  console.log('online');
  consumerQueue = queue.subscribe(send);
});

window.addEventListener('offline', (_e) => {
  console.log('offline');
  consumerQueue.unsubscribe();
});

/**
 *
 * @param {string} scope
 * @param {Object} [ctx]
 * @return {(function(*, {}=): (Kibana|undefined))|*}
 * @constructor
 */
function Kibana(scope, ctx = {}) {
  let scopeContext = {
    ...ctx,
  };
  let _allowedLogLevel;
  Object.defineProperty(this, 'allowedLogLevel', {
    get() {
      return _allowedLogLevel ?? Kibana.allowedLogLevel;
    },
    set(newLogLevel) {
      _allowedLogLevel = newLogLevel;
    },
  });

  this.setContext = (ctx) => {
    Object.assign(scopeContext, ctx);
  };

  this.setLevel = (newLogLevel) => {
    _allowedLogLevel = logLevels.indexOf(newLogLevel);
    if (_allowedLogLevel === -1) {
      console.warn(
        `Unknown log level ${newLogLevel}, ${scope} logger disabled`,
      );
    }
  };

  this.debug = createHandler('debug');
  this.info = createHandler('info');
  this.log = createHandler('log');
  this.warn = createHandler('warn');
  this.error = createHandler('error');
  this.fatal = createHandler('fatal');

  function createPayload(prefix, message, data) {
    const formData = new FormData();
    const payload = {
      send_time: new Date().toISOString(),
      ...sessionContext,
      ...scopeContext,
      ...data,
      scope,
    };

    if (message instanceof Error) {
      formData.append('text', `${prefix}: ${message.message}`);
      payload.details = {
        ...message,
      };
    } else {
      formData.append('text', `${prefix}: ${message}`);
    }
    formData.append('data', JSON.stringify(payload));
    return formData;
  }

  function createHandler(logLevel) {
    const prefix = `${logLevel[0].toUpperCase()}${logLevel.slice(1)}`;
    const level = logLevels.indexOf(logLevel);

    return function (message, data) {
      if (Kibana.enabled === false) {
        return;
      }
      if (level < this.allowedLogLevel) {
        console.info(`SKIP SENDING [${logLevel}]:`, message, data);
        return;
      }
      try {
        const formData = createPayload(prefix, message, data);
        queue.push(formData);
        console.info('push log to queue');
      } catch (error) {
        console.error('create payload failure', error);
      }
    };
  }
}

Kibana.enabled = true;
Kibana.allowedLogLevel = logLevels.indexOf('fatal');
Kibana.setContext = function (name, value) {
  sessionContext[name] = value;
};
Kibana.setLevel = function (newLogLevel) {
  this.allowedLogLevel = logLevels.indexOf(newLogLevel);
  if (this.allowedLogLevel === -1) {
    console.warn(`Unknown log level ${newLogLevel}, global logger disabled`);
  }
};
